<template>
  <div id="contenedor-listado-desktop">
    <v-data-table
      :headers="headers"
      :items="listadoContratistas"
      :items-per-page="20">
      <template
        v-slot:[`item.acciones`]="{ item }">
        <opciones
          :contratista="item">
        </opciones>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import Opciones from './Opciones.vue';

export default {
  name: 'ListadoDesktop',
  props: {
    listadoContratistas: {
      type: Array,
      required: true,
    },
  },
  components: {
    Opciones,
  },
  data() {
    return {
      contratistas: [],
      headers: [
        {
          text: 'RFC',
          align: 'start',
          sortable: false,
          value: 'rfc',
        },
        { text: 'Nombre', value: 'nombreRazonSocial', sortable: false },
        // { text: 'Nacionalidad', value: 'nacionalidad', sortable: false },
        { text: 'Calle', value: 'calle', sortable: false },
        { text: 'Número', value: 'numero', sortable: false },
        { text: 'Colonia', value: 'colonia', sortable: false },
        { text: 'CP', value: 'codigoPostal', sortable: false },
        // { text: 'Entidad', value: 'entidad', sortable: false },
        // { text: 'Municipio', value: 'municipio', sortable: false },
        { text: 'Representante', value: 'nombreRepresentante', sortable: false },
        { text: 'Correo', value: 'correoElectronico', sortable: false },
        { text: '', value: 'acciones', sortable: false },
      ],
    };
  },
  methods: {},
};
</script>

<style lang="scss">

</style>
